export enum ChangelogApplication {
  ATAVITINET = "Atavitinet",
  DAISY = "Daisy",
  INCEPTION = "Inception",
  MYATAVITI = "Myataviti", 
}